import { $t } from '@/i18n';
import { defineComponent, inject } from '@vue/composition-api';
import { usePageletEvent, EVENTS } from '@composables/usePageletEvent';
import { DEFAULT_LESSCODE } from '@components/CodeEditor/utils/codes';
import styles from './index.module.scss';
const XyHeaderContainer = defineComponent({
    name: 'XyHeaderContainer',
    setup(props, { emit }) {
        usePageletEvent({ emit });
        const w = inject('w', null);
        const getDefaultSlot = () => {
            if (w?.mode === 'runtime')
                return null;
            return (<div class={styles.placeholder}>
        <span>{$t('k_e621cb4b')}</span>
      </div>);
        };
        return {
            getDefaultSlot,
        };
    },
    render() {
        return (<div class={['xy-header-container', styles.container]}>
        {this.$slots.default || this.getDefaultSlot()}
      </div>);
    },
});
const componentId = 'xy-header-container';
export const getDefaultHeaderConfig = (id) => ([
    {
        id,
        name: $t('k_dee04081'),
        layout: {
            type: componentId,
            props: {},
            children: [],
            style: {
                height: '50px',
                width: '100%',
                'background-color': 'rgba(255, 255, 255, 1)',
            },
        },
        xyType: 'pagelet',
        lessCode: DEFAULT_LESSCODE,
    },
]);
export default {
    component: XyHeaderContainer,
    componentForDesign: XyHeaderContainer,
    category: $t('k_96601653'),
    id: componentId,
    slots: [
        { id: 'default', selector: '.xy-header-container' },
    ],
    events: EVENTS,
    display: 'block',
    visible: false,
    name: $t('k_dee04081'),
    propsSchema: {
        type: 'object',
        fields: [],
    },
    readme: '',
};
